module.exports = __webpack_public_path__ + "img/broom.cca67efc.png";